import { Component, Input, OnInit, ViewChild, ElementRef, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { PayService } from '../../invoices/pay.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'invoice-pay-deductions',
  templateUrl: './invoice-pay-deductions.component.html',
})
export class InvoicePayDeductionsComponent implements OnInit, AfterViewChecked {
  @Input() payData: any = {};
  @Input() invoice: any = {};
  
  @ViewChild('deductionAmountInput', { static: false }) deductionAmountInput: ElementRef;
  @ViewChild('whtAmountInput', { static: false }) whtAmountInput: ElementRef;
  
  private shouldFocusDeduction = false;
  private shouldFocusWHT = false;
  private previousDeductionReason: any = null;
  private previousWHTReason: any = null;

  constructor(
    private payService: PayService,
    private translate : TranslateService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() { }

  addDeduction(invoice, deductionModel, deductionArr) {
    if (this.payService.validateDeduction(this.payData, invoice, deductionModel)) {
      this.payService.addDeductionToInvoice(this.payData, invoice, deductionModel, deductionArr);
    };
  }

  getDeductionAmountForTDS(invoice, deductionModel) {
    const reasonChanged = this.previousWHTReason !== deductionModel.reason;
    this.previousWHTReason = deductionModel.reason;
    
    this.payService.calculateDeductionAmt(this.payData, invoice, deductionModel);
    
    // Focus on WHT amount input when reason is selected (only if reason changed and not readonly)
    if (reasonChanged && deductionModel.reason && !deductionModel.isreadonly) {
      this.shouldFocusWHT = true;
      this.cdr.detectChanges();
    }
  }

  ngAfterViewChecked() {
    if (this.shouldFocusDeduction && this.deductionAmountInput?.nativeElement) {
      setTimeout(() => {
        this.deductionAmountInput?.nativeElement?.focus();
        this.shouldFocusDeduction = false;
      }, 0);
    }
    if (this.shouldFocusWHT && this.whtAmountInput?.nativeElement) {
      setTimeout(() => {
        this.whtAmountInput?.nativeElement?.focus();
        this.shouldFocusWHT = false;
      }, 0);
    }
  }

  validateDeductionModel(invoice, deductionModel) {
    const reasonChanged = this.previousDeductionReason !== deductionModel.reason;
    this.previousDeductionReason = deductionModel.reason;
    
    deductionModel.isValid = this.payService.validateDeduction(this.payData, invoice, deductionModel);
    
    // Focus on deduction amount input when reason is selected (only if reason changed)
    if (reasonChanged && deductionModel.reason && !deductionModel.amt) {
      this.shouldFocusDeduction = true;
      this.cdr.detectChanges();
    }
  }

  removeDeduction(invoice, deductionIndex, deductionArr) {
    this.payService.removeDeduction(this.payData, invoice, deductionIndex, deductionArr);
  }

  // Attach a supporting document to a single deduction row.
  onSupportingDocSelected(deduction, event) {
    const file = event && event.target && event.target.files && event.target.files[0];
    if (file) {
      deduction.supportingDoc = file;
      deduction.supportingDocName = file.name;
    }
  }

  clearSupportingDoc(deduction, inputEl) {
    deduction.supportingDoc = undefined;
    deduction.supportingDocName = undefined;
    if (inputEl) {
      inputEl.value = '';
    }
  }

  close() {
    
  }  


}

